// extracted by mini-css-extract-plugin
module.exports = {"container":"SignInForm_container__wexu0","sign-in-text":"SignInForm_sign-in-text__K4EGj"};